<div class="w-100 flex-wrap d-flex gap-x-2 gap-y-2 filter-chip-grid">
  <mat-chip-row *ngFor="let filterTag of filtersTagList; index as i"
    (removed)="resetIndiviualFilter(i)" [editable]="true">
    <span class="fw-bold">
      {{ filterTag?.displayControl }}
    </span>
    <br />
    <span [matTooltip]="filterTag?.display" *ngIf="
      filterTag?.display?.length > 20;
      else displayFull
  ">
      {{ filterTag?.display }}
    </span>
    <ng-template #displayFull>
      {{ filterTag?.display }}
    </ng-template>
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>
</div>